module.exports = __webpack_public_path__ + "static/img/mstile-70x70.587f61ab.png";